import { render, staticRenderFns } from "./FlagsList.vue?vue&type=template&id=73ecf6fc&scoped=true&"
import script from "./FlagsList.vue?vue&type=script&lang=ts&"
export * from "./FlagsList.vue?vue&type=script&lang=ts&"
import style0 from "./FlagsList.vue?vue&type=style&index=0&id=73ecf6fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ecf6fc",
  null
  
)

export default component.exports